import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FieldSelect } from 'components/form';
import { useInstitutionSections } from 'api/hooks';

export default function InstitutionSectionsFilter({ onChange, ...rest }) {
  const { institutionSections, isLoading } = useInstitutionSections({});
  const [selectedValue, setSelectedValue] = useState();

  const onSelect = useCallback(
    (option) => {
      setSelectedValue(option);
      onChange(option);
    },
    [onChange],
  );
  return (
    <FieldSelect
      value={selectedValue}
      onChange={(_value, option) => onSelect(option)}
      isLoading={isLoading}
      options={institutionSections ?? []}
      focusColor="indigo"
      {...rest}
    />
  );
}

InstitutionSectionsFilter.propTypes = {
  onChange: PropTypes.func,
};
InstitutionSectionsFilter.defaultProps = {
  onChange: _.noop,
};
